const ROLES = {
  VIEWER: "VIEWER",
  ENTERPRISE_ADMIN: "ENTERPRISE_ADMIN",
  SUKI_ADMIN: "SUKI_ADMIN"
};

const CREATE_USER_ERROR_CODE = {
  DUPLICATE_ENTRY: 13,
  NO_ACCOUNT: 5
};

const ALLOWED_ADMIN_ROLES = [ROLES.VIEWER, ROLES.ENTERPRISE_ADMIN];
const ALLOWED_SUKI_ADMIN_ROLES = [ROLES.VIEWER, ROLES.ENTERPRISE_ADMIN, ROLES.SUKI_ADMIN];

const ROLES_MASK = {
  [ROLES.VIEWER]: "Viewer",
  [ROLES.ENTERPRISE_ADMIN]: "Admin",
  [ROLES.SUKI_ADMIN]: "Suki Admin"
};

const LO_STO = {
  CURRENT_NAME: "CURRENT_NAME",
  CURRENT_PATH: "CURRENT_PATH",
  CURRENT_USER: "CURRENT_USER",
  IS_LOGGING: "IS_LOGGING",
  IS_SUKI_USER_ADMIN: "IS_SUKI_USER_ADMIN",
  JWT_TOKEN: "JWT_TOKEN",
  LOGIN_TIME: "LOGIN_TIME",
  LOGOUT_MESSAGE: "LOGOUT_MESSAGE",
  OKTA_USER: "OKTA_USER",
  ORG_ID: "ORG_ID",
  USER_ID: "USER_ID",
  USER_EMAIL: "USER_EMAIL",
  USER_ROLE: "USER_ROLE"
};

const SESSION_STO = {
  SESSION_TOKEN: "SESSION_TOKEN"
};

const ORGS = {
  SUKI: "11111111-1111-1111-1111-111111111111"
};

export {
  ALLOWED_ADMIN_ROLES,
  ALLOWED_SUKI_ADMIN_ROLES,
  CREATE_USER_ERROR_CODE,
  LO_STO,
  ORGS,
  ROLES,
  ROLES_MASK,
  SESSION_STO
};
